import React, { ReactElement } from "react";
import { LoginContainer } from "../../components";

const LoginPage: React.FC = (): ReactElement => {
  return <LoginContainer />;
};

export { LoginPage };
